import React, { useEffect, useState, useRef } from "react";
import Headers from "@/components/Headers";
import { Business } from "@/constants/breadcrumb";
import Search from "./Search";
import Modal from "./Modal";
import BindModal from "./BindModal";
import Content from "./Content";
import { fetchOperaList, addOpera, editOpera,bindBusiness } from "@/api/business";
import { message } from "antd";
import { 
  canBind, 
} from "@/api/equipment"
import "./index.scss";

const BusinessPage = (props) => { 

  const [visible, setVisible] = useState(false); 

  const [current, setCurrent] = useState({});

  const [bindVisible, setBindVisible] = useState(false);

  const containerRef = useRef(null);

  const [dataSource, setDataSource] = useState([]);

  const [otherParams,setOtherParams]=useState({}); 

  const [page, setPage] = useState({
    pageNum: 1,
    pageSize: 10,
    total: 0,
  });

  const fetchList = () => {
    fetchOperaList({
      pageNum: page.pageNum,
      pageSize: page.pageSize,
      ...otherParams
    }).then((res) => {
      if (res.success) {
        setDataSource(res.data.list);
        setPage({ ...page, total: res.data.total });
      }
    });
  };

  useEffect(() => {
    fetchList();
  }, [page.pageSize, page.pageNum,otherParams]);

  const handleTableChange = (pageNum, pageSize) => {
    setPage({ ...page, pageNum, pageSize });
  };

  const handleShowSizeChange = (pageNum, pageSize) => {
    setPage({ ...page, pageNum: 1, pageSize });
  };

  //新增运营商
  const handleAdd = () => {
    setVisible(true);
  };

  const handleCancel = () => {
    setVisible(false);
    setBindVisible(false);
    setCurrent({});
  };

  const handleConfirm = (type) => (values) => {
    if (type === "add") {
      addOpera(values).then((res) => {
        if (res.success) {
          setVisible(false);
          message.success("添加运营商成功!");
          fetchList();
        }
      });
    } else {
      editOpera(values).then((res) => {
        if (res.success) {
          setVisible(false);
          message.success("编辑运营商成功!");
          fetchList();
        }
      });
    }
  };

  const handleEdit = (record) => {
    setCurrent(record);
    setVisible(true);
  };
 
  const handleSearch=(values)=>{
    setOtherParams({...values})
    setPage({ ...page, pageNum: 1 });
  }

  const handleBind=(record)=>{
    setBindVisible(true);
    setCurrent(record);
    canBindReq()
  } 
  
  const [equipment,setEquipment]=useState([]);

  const canBindReq=()=>{
    canBind().then(res=>{
      if(res.success){
        setEquipment(res.data.map((item)=>({
          label:item.capsuleNo,
          value:item.capsuleId
        })))
      }
    })
  }

  useEffect(()=>{
    canBindReq()
  },[]);

  const onUpdate=(values)=>{
    bindBusiness(values).then(res=>{
      if(res.success){
        message.success("绑定设备成功！")
        setBindVisible(false);
      }
    })
  }

  return (
    <div className="container business-page" ref={containerRef}>
      <Headers BreadCrumbData={Business}></Headers>

      <Search onAdd={handleAdd} onSearch={handleSearch} />

      <Modal
        visible={visible}
        current={current}
        getContainer={() =>
          containerRef ? containerRef.current : document.body
        }
        onCancel={handleCancel}
        onAdd={handleConfirm("add")}
        onEdit={handleConfirm("edit")}
      />

      <BindModal 
        visible={bindVisible}
        current={current}
        onCancel={handleCancel} 
        equipment={equipment}
        onUpdate={onUpdate}
      />

      <Content
        dataSource={dataSource}
        page={page}
        onTableChange={handleTableChange}
        onShowSizeChange={handleShowSizeChange}
        onEdit={handleEdit}
        onBind={handleBind}
      />
    </div>
  );
};
export default BusinessPage;
